import { render, staticRenderFns } from "./EventData.vue?vue&type=template&id=42a6f1e0&scoped=true&"
import script from "./EventData.vue?vue&type=script&lang=js&"
export * from "./EventData.vue?vue&type=script&lang=js&"
import style0 from "./EventData.vue?vue&type=style&index=0&id=42a6f1e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a6f1e0",
  null
  
)

export default component.exports